import ProductBool from './bool';
import ProductText from './Text';
import {
    ProductTextField,
    ProductTextFieldPercentage,
    ProductTextFieldNumber,
    ProductTextFieldDecimal,
    ProductTextFieldCurrency,
    DateTextField,
} from './TextField';
import ProductValueList from './ValueList';
import ProductFuzzySearch from './fuzzySearch';
import ProductPosition from './position';
import ProductName from './ProductName';
import RenderText from './Text';
import StaticText from './StaticText';

const getEntityValueList = (valueListName) => {
    switch (valueListName) {
        case 'Productos':
            return 'products';
        case 'coferta':
            return 'offers';
        case 'Empresas':
            return 'companies';
        case 'Expedientes':
            return 'opportunities';
        case 'viewUsuariosFullName':
            return 'users';
        case 'viewContactosFullName':
            return 'contacts';
        default:
            return undefined;
    }
};

export const RenderField = (props, dataType, rowIndex, pos) => {
    let render;
    const ownProps = { ...props, rowIndex, pos };
    switch (dataType) {
        case 'text':
            render = <ProductTextField {...ownProps} />;
            break;
        case 'integer':
            render = <ProductTextFieldNumber {...ownProps} />;
            break;
        case 'decimal':
            render = <ProductTextFieldDecimal {...ownProps} />;
            break;
        case 'bool':
            render = <ProductBool {...ownProps} />;
            break;
        case 'currency':
            render = <ProductTextFieldCurrency {...ownProps} />;
            break;
        case 'percent':
            render = <ProductTextFieldPercentage {...ownProps} />;
            break;
        case 'date':
            render = <DateTextField {...ownProps} />;
            break;
        case 'message':
            render = <ProductText {...ownProps} />;
            break;
        case 'relatedValueList':
        case 'singleValueList':
            const entityTable = getEntityValueList(props.config.valueListName);
            render = entityTable ? (
                <ProductFuzzySearch {...ownProps} valueListName={entityTable} />
            ) : (
                <ProductValueList {...ownProps} />
            );
            break;
        case 'position':
            render = <ProductPosition {...ownProps} />;
            break;
        case 'productName':
            render = <ProductName {...ownProps} />;
            break;
        case 'staticText':
            render = <StaticText {...ownProps} />;
            break;
        default:
            render = <RenderText {...ownProps} />;
            break;
    }
    return render;
};
